// extracted by css-extract-rspack-plugin
export default {"ProviderLogo":"ProviderLogo-module__ProviderLogo__yWtK5Mr"};